import React from "react";
import AbstractEntity from "./abstractEntity";

/*
teamObj properties:
  - abbr
  - city
  - colors
  - divisionSeason (id)
  - franchise (id)
  - id
  - leagueSeason (id)
  - logos ({logoId: logoObj})
  - nickname
  - roles ({username: roleObj})
  - season
  - slug
 */
class Team extends AbstractEntity {
  constructor(teamObj, userInfo) {
    super(teamObj, userInfo);

    this.loaded = false;
    this.leagueSeasonObj = null;
    this.leagueObj = null;
    this.leagueSlugOrId = null;

    if (this.obj && this.userInfo && this.userInfo.hasLoaded()) {
      // league season
      this.leagueSeasonObj = this.userInfo.getLeagueSeasonObj(
        this.obj.leagueSeason
      );

      // league
      this.leagueObj = this.userInfo.getLeagueObj(this.leagueSeasonObj.league);
      this.leagueSlugOrId = this.leagueObj.slug || this.leagueObj.id;

      this.fullName = `${this.obj.city || ""} ${this.obj.nickname}`.trim();
      this.idOrSlug = this.obj.slug || this.obj.id;

      this.label = this.fullName;
      this.pathDeps = {
        team: this.obj,
        league: this.leagueObj,
        season: this.obj.season,
      };
      this.defaultPathName = "teamHome";

      this.loaded = true;
    }
  }

  getAbbrSpan() {
    return <span title={this.fullName}>{this.obj.abbr}</span>;
  }

  /**
   *
   * @returns {object}
   */
  getDivisionSeasonObj() {
    if (!this.obj.divisionSeason) return null;
    return this.userInfo.getDivisionSeasonObj(this.obj.divisionSeason);
  }

  /**
   *
   * @returns {boolean}
   */
  hasLoaded() {
    return this.loaded;
  }
}

export default Team;
